import * as _ from 'lodash'
import React from 'react';
import componentServices from '../componentServices';
import * as contractorActions from '../contractorActions';
import * as actions from '../actions';
import enums from '../enum';
import util from '../util';
import globalRelay from '../globalRelay';
import jobCostPaymentTermFactory from '../models/jobCostPaymentTermModel';
import jobCostScheduleItemFactory from '../models/jobCostScheduleItemModel';
import jobFactory from '../models/jobModel';
import { AsyncButton, NumericInput, Radio, TooltipTarget } from './sharedComponents';
import { BalanceSection, TermsSection } from './jobCostEditFinalizeShared';
import { DayPickerInput } from './dayPickerInput';
import ScopeOfWork from '../models/scopeOfWork';
import { getCollection, getModel, ModelCollection } from 'Scripts/store';

function formatContact (contact) {
	const parts:any[] = [];

	if (contact) {
		if (contact.fullName) {
			parts.push(contact.fullName);
		}
		if (contact.preferredContactMethodValue) {
			parts.push(contact.preferredContactMethodValue);
		}
	}

	return parts.length ? parts.join(' - ') : '';
}

function formatAddress (address) {
	return address ? `${address.street}, ${address.city}, ${address.region} ${address.postalCode}` : '';
}

class PaymentLockAlert extends React.Component<any,any> {
	render () {
		const { message, applyAction } = this.props;
		const cancelLabel = applyAction ? 'Cancel' : 'OK';

		return (<div className="alert warning">
			<section>
				<header><span>PAYMENT LOCKED</span></header>
				<div className="content">{ message }
					<div className="actions">
						<button onClick={ actions.popModal }><span>{ cancelLabel }</span></button>
						{ applyAction ? <button onClick={ applyAction }><span>Apply to this Estimate</span></button> : null }
					</div>
				</div>
			</section>
		</div>);
	}
}

class PaymentsSection extends React.Component<any,any> {
	handleChange (key, e) {
		this.props.onSelectionChange(key, e.target.checked);
	}

	handleLockClick (paymentItem) {
		const { store } = componentServices;
		const owningJobCost = getModel({ store, collection: ModelCollection.jobCosts, key: paymentItem.model.jobCostKey});
		const isUnlocked = ['unlocked', 'rejected'].indexOf(owningJobCost.currentStatus) !== -1;
		let message = '';
		let applyAction;

		if (owningJobCost.isContract) {
			message = `This Payment has already been applied to a Contract (${owningJobCost.relayNumber}).`;
		}
		else if (isUnlocked) {
			message = `This Payment has already been applied to ${owningJobCost.relayNumber}. Would you like to unlock the Payment and apply it to this Estimate instead?`;
			applyAction = () => {
				this.props.forceApplyPayment(paymentItem.key);
				setTimeout(actions.popModal, 0);
			};
		}
		else {
			message = `This Payment has already been applied to another Estimate. You'll need to Unfinalize ${owningJobCost.relayNumber} if you'd like to apply the Payment to this Estimate.`;
		}

		actions.pushModal({ component: <PaymentLockAlert message={ message } applyAction={ applyAction } /> });
	}

	render () {
		const { className, isLocked, jobCost, paymentItems } = this.props;
		const rows = _.map(paymentItems, item => {
			const showRowLock = item.model.jobCostKey && item.model.jobCostKey !== jobCost.key && !item.forceApplication;
			return (<tr key={item.key} className="added">
				<td />
				<td className="jobNumber"><label className={ showRowLock ? 'disabled' : '' }><input type="checkbox" checked={ item.selected } onChange={ this.handleChange.bind(this, item.key) } />{ item.model.relayNumber }</label></td>
				<td>{ _.startCase(item.model.type) }</td>
				<td>{ item.model.description || '-' }</td>
				<td className="price">{ util.formatAsCurrency(item.model.amount) }</td>
				<td> { showRowLock ? <button className="icon iconOnly locked" onClick={ this.handleLockClick.bind(this, item) }><span /></button> : null }</td>
				<td />
			</tr>);
		});

		return (<section className={ className }>
			<header>
				<span>APPLY PAYMENTS</span>
			</header>
			<div className={'inner' + (isLocked ? ' readOnly' : '')}>

				<table className="compact" cellPadding="0" cellSpacing="0">
					<thead>
						<tr>
							<td />
							<td className="jobNumber"><label style={{ textDecoration: 'none', cursor: 'auto' }}><input type="checkbox" style={ { visibility: 'hidden' }} />Relay No.</label></td>
							<td>Payment Type</td>
							<td>Description</td>
							<td className="price">Amount</td>
							<td className="actions" />
							<td />
						</tr>
					</thead>
					<tbody>
						{ rows }
					</tbody>
				</table>

			</div>
		</section>);
	}
}

class AdditionalInfoSection extends React.Component<any,any> {
	constructor (props) {
		super(props);
	}

	onOffsetChange (item, e) {
		const { onItemChange } = this.props;
		const newVal = Number(e.target.value);

		onItemChange(item, newVal);
	}

	onSettingChange (item, e) {
		const { onItemChange } = this.props;
		const newVal = e.target.value;

		onItemChange(item, newVal);
	}

	onButtonChange (item, newButton) {
		const { onItemChange } = this.props;

		onItemChange(item, newButton.value);
	}

	onDateChange (item, { date }) {
		const { onItemChange } = this.props;
		onItemChange(item, date ? util.dateHelper.formatDate(date, { format: 'MM/dd/yyyy' }) : '');
	}

	render () {
		const { className, isLocked, additionalInfoItems } = this.props;
		const rows:JSX.Element[] = [];

		_.forEach(additionalInfoItems, item => {
			if (item.type === 'schedule-offset') {
				const settingKey = `${item.itemKey}-offset`;
				const value = item.value.date ? util.dateHelper.formatDate(item.value.date, { format: 'MM/dd/yyyy' }) : '-';

				if (!isLocked) {
					rows.push(<tr key={ settingKey }>
						<td />
						<td><strong>{ item.label }</strong></td>
						<td className={ item.isValid && !item.isValid(item.value) ? 'required' : '' }>
							<select className="select" value={ item.offsetValue || '' } onChange={ this.onOffsetChange.bind(this, item) }>
								<option value="">Select</option>
								{ _.map(item.offsets, offset => <option key={ offset.value } value={ offset.value }>{ offset.label }</option>)}
							</select>
						</td>
						<td>{ item.helpText ? <TooltipTarget text={item.helpText}><button tabIndex={ - 1} className="icon iconOnly info"><span /></button></TooltipTarget> : null }</td>
						<td />
					</tr>);
				}

				rows.push(<tr key={ item.itemKey }>
					<td />
					<td><strong>{ `${item.label} Date` }</strong></td>
					<td><span className="readOnly">{ value }</span></td>
					<td />
				</tr>);
			}
			else if (item.type === 'setting') {
				if (item.input === 'numeric') {
					rows.push(<tr key={ item.itemKey }>
						<td />
						<td><strong>{ item.label }</strong></td>
						<td className={ item.isValid && !item.isValid(item.value) ? 'required' : '' }><NumericInput value={ item.value } onChange={ this.onSettingChange.bind(this, item) } /></td>
						<td>{ item.helpText ? <TooltipTarget text={item.helpText}><button tabIndex={ - 1} className="icon iconOnly info"><span /></button></TooltipTarget> : null }</td>
						<td />
					</tr>);
				}
				else if (item.input === 'text') {
					rows.push(<tr key={ item.itemKey }>
						<td />
						<td><strong>{ item.label }</strong></td>
						<td className={ item.isValid && !item.isValid(item.value) ? 'required' : '' }><input type="text" value={ item.value } onChange={ this.onSettingChange.bind(this, item) } /></td>
						<td>{ item.helpText ? <TooltipTarget text={item.helpText}><button tabIndex={ - 1} className="icon iconOnly info"><span /></button></TooltipTarget> : null }</td>
						<td />
					</tr>);
				}
				else if (item.input === 'date') {
					rows.push(<tr key={ item.itemKey }>
						<td />
						<td><strong>{ item.label }</strong></td>
						<td className={ item.isValid && !item.isValid(item.value) ? 'required' : '' }>
							<DayPickerInput placeholder="Select a Date" selectedDate={ new Date(item.value) } isVertical={ true } onDateSelected={ this.onDateChange.bind(this, item) } />
						</td>
						<td>{ item.helpText ? <TooltipTarget text={item.helpText}><button tabIndex={ - 1} className="icon iconOnly info"><span /></button></TooltipTarget> : null }</td>
						<td />
					</tr>);
				}
				else if (item.input === 'select') {
					rows.push(<tr key={ item.itemKey }>
						<td />
						<td><strong>{ item.label }</strong></td>
						<td className={ item.isValid && !item.isValid(item.value) ? 'required' : '' }>
							<select className="select" value={ item.value || '' } onChange={ this.onSettingChange.bind(this, item) }>
								<option value="">Select</option>
								{ _.map(item.values, v => <option key={ v.value } value={ v.value }>{ v.label }</option>)}
							</select>
						</td>
						<td>{ item.helpText ? <TooltipTarget text={item.helpText}><button tabIndex={ - 1} className="icon iconOnly info"><span /></button></TooltipTarget> : null }</td>
						<td />
					</tr>);
				}
				else if (item.input === 'bool') {
					const itemButtons = [
						{ classNames: ['icon yes'], isSelected: (item.value === '1'), value: '1' },
						{ classNames: ['icon no'], isSelected: (item.value === '0'), value: '0' }
					];
					const itemClasses:string[] = [];

					if (item.value === '1') {
						itemClasses.push('yes');
					}
					else if (item.value === '0') {
						itemClasses.push('no');
					}

					if (!item.isValid(item.value)) {
						itemClasses.push('required');
					}

					rows.push(<tr key={ item.itemKey }>
						<td />
						<td><strong>{ item.label }</strong></td>
						<td className={ itemClasses.join(' ') }>
							<Radio buttons={ itemButtons } onChange={ this.onButtonChange.bind(this, item) } reportAllEvents={ true } />
						</td>
						<td>{ item.helpText ? <TooltipTarget text={item.helpText}><button tabIndex={ - 1} className="icon iconOnly info"><span /></button></TooltipTarget> : null }</td>
						<td />
					</tr>);
				}
			}
		});

		return	(<section className={ className }>
			<header><span>ADDITIONAL CONTRACT INFORMATION</span></header>
			<div className={'inner compact' + (isLocked ? ' readOnly' : '')}>
				<table cellPadding="0" cellSpacing="0">
					<tbody>
						{ rows }
					</tbody>
				</table>
			</div>
		</section>);
	}
}

const RejectionTable = ({ getEmployeeByUserId, onRejectionResolvedChange, rejectionStatus, rejectionResolved = '0' }) => {
	const rejector = getEmployeeByUserId(rejectionStatus.createdById);
	const rejectionrResolvedButtons = [
		{ classNames: ['icon yes'], isSelected: (rejectionResolved === '1'), value: '1' },
		{ classNames: ['icon no'], isSelected: (rejectionResolved === '0'), value: '0' }
	];

	const rejectionResolvedRadio = (<Radio buttons={ rejectionrResolvedButtons } onChange={ onRejectionResolvedChange } />);

	return (<table cellPadding="0" cellSpacing="0">
		<tbody>
			<tr>
				<td />
				<td><strong>Rejected By</strong></td>
				<td>{ rejector && rejector.fullName }</td>
				<td />
			</tr>
			<tr>
				<td />
				<td><strong>Rejected On</strong></td>
				<td>{ util.dateHelper.formatDate(rejectionStatus.dateCreated, { userFriendly: true }) }</td>
				<td />
			</tr>
			<tr>
				<td />
				<td><strong>Reason</strong></td>
				<td>{ rejectionStatus.description }</td>
				<td />
			</tr>
			{ /*  If user selects Yes below, set TR className to 'yes' or if No, set it to 'no' */ }
			<tr className={ rejectionResolved === '1' ? 'yes' : rejectionResolved === '0' ? 'no' : '' }>
				<td />
				<td><strong>Has this been resolved?</strong></td>
				<td>
					{ rejectionResolvedRadio }
				</td>
				<td />
			</tr>
		</tbody>
	</table>);
};

const InfoTable = ({ builder, onInfoButtonChange, hasSpecs = undefined, infoCorrect = '0', job, jobTypeName = '' }) => {
	const infoCorrectButtons = [
		{ classNames: ['icon yes'], isSelected: (infoCorrect === '1'), value: '1' },
		{ classNames: ['icon no'], isSelected: (infoCorrect === '0'), value: '0' }
	];
	const hasSpecsButtons = [
		{ classNames: ['icon yes'], isSelected: (hasSpecs === '1'), value: '1' },
		{ classNames: ['icon no'], isSelected: (hasSpecs === '0'), value: '0' }
	];

	const infoCorrectRadio = (<Radio buttons={ infoCorrectButtons } onChange={ onInfoButtonChange.bind(null, 'infoCorrect') } />);
	const hasSpecsRadio = (<Radio buttons={ hasSpecsButtons } onChange={ onInfoButtonChange.bind(null, 'hasSpecs') } />);

	const builderRows = builder
		&& [<tr key="builder-name">
			<td />
			<td><strong>Builder</strong></td>
			<td>{ builder.name }</td>
			<td />
		</tr>,
		<tr key="builder-contact">
			<td />
			<td><strong>Builder Primary Contact</strong></td>
			<td>{ formatContact(builder.primaryContact) }</td>
			<td />
		</tr>];

	return (<table cellPadding="0" cellSpacing="0">
		<tbody>
			<tr>
				<td />
				<td><strong>Job Type</strong></td>
				<td>{ jobTypeName }</td>
				<td />
			</tr>
			{ builderRows }
			<tr>
				<td />
				<td><strong>Client Primary Contact</strong></td>
				<td>{ formatContact(job.primaryClientContact) }</td>
				<td />
			</tr>
			<tr>
				<td />
				<td><strong>Billing Address</strong></td>
				<td>{ formatAddress(job.billingAddress) }</td>
				<td />
			</tr>
			<tr>
				<td />
				<td><strong>Delivery Address</strong></td>
				<td>{ formatAddress(job.workSiteAddress) }</td>
				<td />
			</tr>
			<tr className={ infoCorrect === '1' ? 'yes' : infoCorrect === '0' ? 'no' : '' }>
				<td />
				<td><strong>Is this information correct?</strong></td>
				<td>
					{ infoCorrectRadio }
				</td>
				<td />
			</tr>
			<tr className={ hasSpecs === '1' ? 'yes' : hasSpecs === '0' ? 'no' : '' }>
				<td />
				<td><strong>Have all customer specs?</strong></td>
				<td>
					{ hasSpecsRadio }
				</td>
				<td />
			</tr>
		</tbody>
	</table>);
};

export default class JobCostFinalize extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(props);

		this.forceApplyPayment = this.forceApplyPayment.bind(this);
		this.handleButtonClick = this.handleButtonClick.bind(this);
		this.onInfoButtonChange = this.onInfoButtonChange.bind(this);
		this.onRejectionResolvedChange = this.onRejectionResolvedChange.bind(this);
		this.onPaymentSelectionChange = this.onPaymentSelectionChange.bind(this);
		this.onTermsChange = this.onTermsChange.bind(this);
		this.onAdditionalInfoItemChange = this.onAdditionalInfoItemChange.bind(this);
		this.printReport = this.printReport.bind(this);
		this.calculateTerms = this.calculateTerms.bind(this);
		this._calculateTerms = this._calculateTerms.bind(this);
	}

	printReport () {
		const { fetchReport } = this.props;
		const { scopeOfWork } = this.state;

		// write the current scope of work to the data rather than the persisted scope of work
		return fetchReport('contract/quote', data => {
			const jobCostData = data.jobCosts[0];

			_.forEach(_.filter(jobCostData.settings, { group: enums.jobCostSettingGroups.Scope_Of_Work }), item => {
				const index = jobCostData.settings.indexOf(item);
				if (index >= 0) {
					jobCostData.settings.splice(index, 1);
				}
			});

			_.forEach(_.filter(scopeOfWork.items, item => item.value !== null), item => {
				jobCostData.settings.push(item);
			});

			return data;
		});
	}

	UNSAFE_componentWillReceiveProps (newProps) {
		this.setState(this.getStateFromProps(newProps));
	}

	getStateFromProps (props) {
		const { store } = componentServices;
		const { jobCost, summary } = props;
		const state = _.assign({ infoCorrect: undefined, hasSpecs: undefined, rejectionResolved: undefined, contractAmount: summary.grandTotalContract, paymentAmount: 0, termAmount: 0 }, this.state);
		const job = getModel({ store, collection: ModelCollection.jobs, key: jobCost.jobKey});
		const globalConfig = globalRelay.config!;
		const builder = job.builderKey ? getModel({ store, collection: ModelCollection.contractors, key: job.builderKey }): undefined;

		if ((!job.builderKey || builder) && (state.jobCostKey !== jobCost.key || state.jobCostItemVersion !== jobCost.itemVersion)) {
			state.jobTypeName = enums.businessSegments.getName(job.businessSegment);
			state.builder = builder;

			if (job.businessSegment === enums.businessSegments.Retail) {
				if (jobCost.getLineItemsByType('subtrade').length) {
					state.jobTypeName = globalConfig.getString('Ren-L');
				}
				else if (builder) {
					state.jobTypeName = job.isRenovation ? globalConfig.getString('Ren-C') : globalConfig.getString('Ret-C');
				}
				else {
					state.jobTypeName = job.isRenovation ? globalConfig.getString('Ren-H') : globalConfig.getString('Ret-H');
				}
			}

			state.infoCorrect = jobCost.jobInfoConfirmed;
			state.hasSpecs = jobCost.hasAllSpecs;
			state.scopeOfWork = new ScopeOfWork(jobCost, job);

			state.job = job;
			state.jobCostKey = jobCost.key;
			state.jobCostItemVersion = jobCost.itemVersion;

			state.paymentAmount = 0;
			state.paymentItems = _.map(_.sortBy(job.payments, ['dateCreated']), payment => {
				const selected = !!(payment.jobCostKey === jobCost.key && payment.appliedToContract);

				if (selected) {
					state.paymentAmount = util.roundAsCurrency(state.paymentAmount + payment.amount);
				}

				return {
					key: payment.key,
					selected: selected,
					model: payment
				};
			});

			const paymentTermsKey = (builder && builder.paymentTermsKey) || 'default';
			const termConfigState = {
				termsConfig: globalConfig.jobCostSettings.paymentTerms[paymentTermsKey] || globalConfig.jobCostSettings.paymentTerms.default
			};

			globalRelay.filterState('paymentTermsConfig', { job, jobCost, builder }, termConfigState);
			state.termConfig = termConfigState.termsConfig;
			this._calculateTerms(false, state);
			this.fillAdditionalInfo(state);
		}

		if (!builder && job.builderKey) {
			contractorActions.fetchContractor({ key: job.builderKey });
		}

		return state;
	}

	fillAdditionalInfo (state) {
		const { jobCost } = this.props;
		const { builder, job } = state;
		const isLocked = ['unlocked', 'rejected'].indexOf(jobCost.currentStatus) === -1;
		const additionalInfoConfigState = {
			additionalInfoConfig: { items: []}
		};

		globalRelay.filterState('finalizeAdditionalInfoConfig', { job, jobCost, builder }, additionalInfoConfigState);
		state.additionalInfoConfig = additionalInfoConfigState.additionalInfoConfig;

		_.forEach(state.additionalInfoConfig.items, item => {
			if (item.type === 'schedule-offset') {
				const settingKey = `${item.itemKey}-offset`;
				const setting = jobCost.getSetting(enums.jobCostSettingGroups.General, settingKey);
				const scheduleSpec = { type: item.itemKey };

				item.value = jobCostScheduleItemFactory(_.find(jobCost.scheduleItems, scheduleSpec) || scheduleSpec);
				item.offsetValue = setting && Number(setting.value);

				if (!isLocked) {
					this._onAdditionalInfoItemChange(item, item.offsetValue, state);
				}
			}
			else if (item.type === 'setting') {
				item.value = jobCost.getSettingValue(item.settingGroup, item.itemKey);
			}
		});
	}

	getEmployeeByUserId (userId) {
		const { store } = componentServices;
		const employees = getCollection({ store, collection: ModelCollection.employees});

		return employees.find(f => f.user.key === userId);
	}

	applyPayment (paymentItem) {
		paymentItem.selected = true;
	}

	onInfoButtonChange (key, newButton) {
		if (['unlocked', 'rejected'].indexOf(this.props.jobCost.currentStatus) === -1) {
			return;
		}

		// set state to force a re-render
		this.setState(previousState => {
			const newState = _.assign({}, previousState);

			newState[key] = newButton.value;

			return newState;
		});
	}

	onRejectionResolvedChange (newButton) {
		if (['unlocked', 'rejected'].indexOf(this.props.jobCost.currentStatus) === -1) {
			return;
		}

		// set state to force a re-render
		this.setState(previousState => {
			const newState = _.assign({}, previousState);

			newState.rejectionResolved = newButton.value;

			return newState;
		});
	}

	handleSettingChange (setting, newButton) {
		if (['unlocked', 'rejected'].indexOf(this.props.jobCost.currentStatus) === -1) {
			return;
		}
		const { scopeOfWork } = this.state;
		const currentValue = scopeOfWork.getValue(setting.key);
		let newValue;

		if (currentValue === newButton.value) {
			newValue = null;
		}
		else {
			newValue = newButton.value;
		}

		this.setState(previousState => {
			const newState = _.assign({}, previousState);

			newState.scopeOfWork.setValue(setting.key, newValue);

			return newState;
		});
	}

	canFinalize () {
		const { jobCost } = this.props;
		const { builder, additionalInfoConfig } = this.state;
		const { contractAmount, paymentAmount, termAmount, scopeOfWork, hasSpecs, infoCorrect, rejectionResolved } = this.state;
		const statusPasses = jobCost.currentStatus !== 'rejected' || (jobCost.currentStatus === 'rejected' && rejectionResolved === '1');
		const balance = Number((contractAmount - (paymentAmount + termAmount)).toFixed(2));
		const builderPasses = jobCost.currentStatus === 'locked' || !builder || builder.currentStatus !== 'locked';
		const additinalInfoPasses = !_.some(additionalInfoConfig.items, item => item.isValid && !item.isValid(item.value));

		return builderPasses && statusPasses && additinalInfoPasses && infoCorrect === '1' && ['0', '1'].indexOf(hasSpecs) !== -1 && scopeOfWork.isComplete && balance === 0;
	}

	onPaymentSelectionChange (paymentKey, state) {
		const item = _.find(this.state.paymentItems, { key: paymentKey });

		if (item) {
			item.selected = state;
			if (item.forceApplication && !state) {
				item.forceApplication = false;
			}
			const items = [].concat(this.state.paymentItems);
			const paymentAmount = _.reduce(items, (sum, p) => sum + ((p.selected && p.model.amount) || 0), 0);

			this.setState({ paymentItems: items, paymentAmount: paymentAmount });
		}
	}

	forceApplyPayment (paymentKey) {
		const item = _.find(this.state.paymentItems, { key: paymentKey });

		if (item) {
			item.selected = item.forceApplication = true;
			const items = [].concat(this.state.paymentItems);
			const paymentAmount = _.reduce(items, (sum, p) => sum + ((p.selected && p.model.amount) || 0), 0);

			this.setState({ paymentItems: items, paymentAmount: paymentAmount });
		}
	}

	calculateTerms (reset) {
		this.setState(previousState => {
			const newState = _.assign({}, previousState);

			this._calculateTerms(reset, newState);

			return newState;
		});
	}

	_calculateTerms (reset, state) {
		const { jobCost } = this.props;
		const totalDue = util.roundAsCurrency(state.contractAmount - state.paymentAmount);
		const existingTerms = _.sortBy(jobCost.paymentTerms, ['sortIndex']);
		const existingTotal = reset ? _.reduce(existingTerms, (sum, t) => util.roundAsCurrency(sum + util.roundAsCurrency(t.amountDue)), 0) : 0;

		state.termAmount = 0;
		state.termItems = _.map(existingTerms.length ? existingTerms : state.termConfig.payments, term => {
			let amountDue = term.amountDue;

			if (typeof amountDue === 'undefined') {
				amountDue = util.roundAsCurrency(term.percentDue * totalDue);
			}
			else if (reset) {
				amountDue = util.roundAsCurrency((amountDue / existingTotal) * totalDue);
			}

			state.termAmount = util.roundAsCurrency(state.termAmount + amountDue);

			return jobCostPaymentTermFactory({
				key: term.key || util.generateGuid(),
				sortIndex: term.sortIndex,
				description: term.description,
				amountDue: amountDue
			});
		});

		if ((reset || !existingTerms.length) && totalDue !== state.termAmount) {
			const diff = totalDue - state.termAmount;
			const lastItem = _.last(state.termItems);
			lastItem.amountDue = util.roundAsCurrency(lastItem.amountDue + diff);
			state.termAmount = util.roundAsCurrency(state.termAmount + diff);
		}
	}

	onTermsChange (newTerms) {
		const { contractAmount } = this.state;
		let termAmount = util.roundAsCurrency(_.reduce(newTerms, (sum, t) => util.roundAsCurrency(sum + util.roundAsCurrency(t.amountDue)), 0));
		const items = [].concat(this.state.paymentItems);
		const paymentAmount = util.roundAsCurrency(_.reduce(items, (sum, p) => util.roundAsCurrency(sum + ((p.selected && p.model.amount) || 0)), 0));
		const termAndPaymentAmount = termAmount + paymentAmount;

		if (contractAmount !== termAndPaymentAmount) {
			const diff = contractAmount - termAndPaymentAmount;
			const lastItem = _.last(newTerms);
			lastItem.amountDue = util.roundAsCurrency(lastItem.amountDue + diff);
			termAmount = util.roundAsCurrency(termAmount + diff);
		}

		this.setState({ termItems: newTerms, termAmount: termAmount });
	}

	onAdditionalInfoItemChange (item, newVal) {
		this.setState(prevState => {
			const nextState = _.assign({}, prevState);

			this._onAdditionalInfoItemChange(item, newVal, nextState);

			return nextState;
		});
	}

	_onAdditionalInfoItemChange (item, newVal, state) {
		const { jobCost } = this.props;
		if (item.type === 'schedule-offset') {
			item.offsetValue = newVal;

			if (item.offsetValue) {
				const timestamp = Date.now() + item.offsetValue;
				const date = new Date(timestamp);

				item.value.date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
			}
			else {
				item.value.date = undefined;
			}
		}
		else if (item.type === 'setting') {
			jobCost.setSetting(item.settingGroup, item.itemKey, undefined, newVal);
			item.value = jobCost.getSettingValue(item.settingGroup, item.itemKey);
		}

		state.additionalInfoConfig = _.assign({}, state.additionalInfoConfig);
	}

	handleButtonClick () {
		const { store } = componentServices;
		const options = { autoSave: true };
		const { jobCost: jc, summary } = this.props;
		const { hasSpecs, job, scopeOfWork, termItems, paymentAmount, paymentItems, additionalInfoConfig } = this.state;
		const accountManager = getModel({ store, collection: ModelCollection.employees, key: job.accountManagerKey});
		const isLocked = jc.currentStatus === 'locked';
		const saveState = componentServices.store.getIn(['viewState', 'globalSave', 'state']);

		if ((!isLocked && !this.canFinalize()) || saveState !== 0) { return; }

		this.props.updateModel(jobCost => {
			let jobUpdate;

			if (['unlocked', 'rejected'].indexOf(jobCost.currentStatus) !== -1) {
				scopeOfWork.writeTo(jobCost);
				jobCost.statusLog.add({ status: 'locked' });
				jobCost.paymentTerms = termItems;
				jobCost.jobInfoConfirmed = '1';
				jobCost.hasAllSpecs = hasSpecs;

				// save value data
				_.forEach(additionalInfoConfig.items, item => {
					if (item.type === 'schedule-offset') {
						const settingKey = `${item.itemKey}-offset`;

						if (item.offsetValue) {
							jobCost.setSetting(enums.jobCostSettingGroups.General, settingKey, undefined, item.offsetValue.toString());
							jobCost.scheduleItems[item.value.key] = item.value;
						}
						else {
							jobCost.setSetting(enums.jobCostSettingGroups.General, settingKey, undefined, undefined);
							jobCost.scheduleItems.delete(item.value.key);
						}
					}
					else if (item.type === 'setting') {
						jobCost.setSetting(item.settingGroup, item.itemKey, undefined, item.value);
					}
				});

				// lock in tax warranty and other calculated costs
				summary.writeCalculatedItems(jobCost);
				summary.writeStats(jobCost, undefined, paymentAmount);

				// lock in sales commission rate
				jobCost.salesCommissionPercent = (accountManager && accountManager.salesCommissionPercent) ? accountManager.salesCommissionPercent : 0;

				// save the payments application
				jobUpdate = jobFactory(job.toDocument());

				_.forEach(jobUpdate.payments, p => {
					const applied = _.some(paymentItems, pi => pi.key === p.key && pi.selected);
					if (applied) {
						// TODO: evaluate if the appliedToContract flag can be removed and use the existence of jobCostKey instead
						p.appliedToContract = true;
						p.jobCostKey = jobCost.key;
					}
				});
			}
			else if (isLocked) {
				// scopeOfWork.erase(jobCost.proxiedContract);
				jobCost.proxiedContract.statusLog.add({ status: 'unlocked' });
				// jobCost.proxiedContract.paymentTerms = [];

				// clear the sales commission rate
				jobCost.proxiedContract.salesCommissionPercent = 0;

				jobCost.proxiedContract.paymentTerms = [];

				// clear tax and warranty costs
				summary.eraseCalculatedItems(jobCost.proxiedContract);
				summary.eraseStats(jobCost.proxiedContract);

				jobUpdate = jobFactory(job.toDocument());
			}

			const jobPatch = jobUpdate.getPatch(job);

			if (jobPatch.length) {
				(options as any).extraneousPatch = [{
					op: 'replace',
					path: '../job',
					value: jobPatch
				}];
			}
		}, options);
	}

	render () {
		const { jobCost } = this.props;
		const { contractAmount, hasSpecs, infoCorrect, paymentAmount, paymentItems, rejectionResolved, additionalInfoConfig, scopeOfWork, termAmount, termConfig, termItems } = this.state;

		if (!jobCost || !scopeOfWork) { return null; }

		const submitButtonClasses = ['action', 'iconLabel'];
		const isLocked = ['unlocked', 'rejected'].indexOf(jobCost.currentStatus) === -1;
		const balance = Number((contractAmount - (paymentAmount + termAmount)).toFixed(2));
		const scopeOfWorkIsComplete = scopeOfWork.isComplete;
		const checklistItems = _.map(_.sortBy(scopeOfWork.items, 'sortIndex'), setting => {
			const scopeItemButtons = [
				{ classNames: ['icon yes'], isSelected: (setting.value === '1'), value: '1' },
				{ classNames: ['icon no'], isSelected: (setting.value === '0'), value: '0' }
			];
			const settingIsRequired = scopeOfWork.isRequired(setting.key);
			const rowClasses = (!scopeOfWorkIsComplete && !settingIsRequired) ? ['disabled'] : [];

			if (setting.value === '1') {
				rowClasses.push('yes');
			}
			else if (setting.value === '0') {
				rowClasses.push('no');
			}

			return (
				<tr className={ rowClasses.join(' ') } key={ setting.key }>
					<td />
					<td>{ setting.name }</td>
					<td>
						<Radio buttons={ scopeItemButtons } onChange={ b => this.handleSettingChange(setting, b) } reportAllEvents={ !settingIsRequired } />
					</td>
					<td />
				</tr>
			);
		});

		if (isLocked) {
			submitButtonClasses.push('unlock');
		}
		else {
			submitButtonClasses.push('finalize');
		}

		if (!isLocked && !this.canFinalize()) {
			submitButtonClasses.push('disabled');
		}

		const submitButtonText = jobCost.currentStatus === 'locked' ? 'UNLOCK & RESET' : 'FINALIZE';
		const submitButton = ['unlocked', 'locked', 'rejected'].indexOf(jobCost.currentStatus) !== -1 ? (<button className={ submitButtonClasses.join(' ') } onClick={ this.handleButtonClick }><span> { submitButtonText }</span></button>) : null;

		const infoTable = (<InfoTable onInfoButtonChange={ this.onInfoButtonChange } builder={ this.state.builder } job={ this.state.job } { ...this.state } />);
		const mainHeaderText = jobCost.currentStatus === 'rejected' ? 'REJECTED' : 'REVIEW JOB INFORMATION';
		let mainTable = infoTable;
		let secondaryTable: any = null;
		let secondarySection: any = null;
		let mainActions: any = (<div className="actions">
			<AsyncButton className={ (infoCorrect === '1' && ['0', '1'].indexOf(hasSpecs) !== -1 && scopeOfWork.isComplete) ? 'pdf' : 'pdf disabled'} asyncAction={ this.printReport } label="Print Quotation" />
		</div>);

		if (jobCost.currentStatus === 'rejected') {
			secondaryTable = infoTable;
			mainTable = <RejectionTable getEmployeeByUserId={ this.getEmployeeByUserId } onRejectionResolvedChange={ this.onRejectionResolvedChange } rejectionStatus={ jobCost.currentStatusItem } { ...this.state } />;
		}

		if (secondaryTable) {
			const mainActionsRef = mainActions;

			mainActions = null;
			secondarySection = (<section className={ rejectionResolved !== '1' ? 'disabled' : '' }>
				<header>
					<span>REVIEW JOB INFORMATION</span>
					{ mainActionsRef }
				</header>
				<div className={ `inner compact ${(isLocked ? 'readOnly' : '')}` }>
					{ secondaryTable }
				</div>
			</section>);
		}

		return (
			<section className={ 'jobCostFinalize' + (jobCost.currentStatus === 'rejected' ? ' rejected' : '') }>
				<header>
					<span>{ mainHeaderText }</span>
					{ mainActions }
				</header>
				<div className={ `inner compact ${(isLocked ? 'readOnly' : '')}` }>
					{ mainTable }
				</div>

				{ secondarySection }

				{ /*  Scope Checklist  */ }
				{ checklistItems.length ? <section className={ infoCorrect !== '1' || ['0', '1'].indexOf(hasSpecs) === -1 ? 'disabled' : '' }>
					<header>
						<span>CONFIRM JOB SCOPE</span>
					</header>
					<div className={ `inner compact ${(isLocked ? 'readOnly' : '')}` }>

						<table className="" cellPadding="0" cellSpacing="0">
							<tbody>
								{ checklistItems }
							</tbody>
						</table>

					</div>
				</section> : null }

				{ additionalInfoConfig.items.length ? <AdditionalInfoSection onItemChange={ this.onAdditionalInfoItemChange } additionalInfoItems={ additionalInfoConfig.items } className={ (infoCorrect === '1' && ['0', '1'].indexOf(hasSpecs) !== -1 && scopeOfWork.isComplete) ? 'bringToFront' : 'disabled'} isLocked={ isLocked } /> : null }
				<PaymentsSection jobCost={ jobCost } onSelectionChange={ this.onPaymentSelectionChange } forceApplyPayment={ this.forceApplyPayment } paymentItems={ paymentItems } className={ (infoCorrect === '1' && ['0', '1'].indexOf(hasSpecs) !== -1 && scopeOfWork.isComplete) ? '' : 'disabled'} isLocked={isLocked} />
				<TermsSection terms={ termItems } onTermsChange={ this.onTermsChange } minAmount={ Number((contractAmount * (termConfig.minPercent || 0)).toFixed(2)) } className={ (infoCorrect === '1' && ['0', '1'].indexOf(hasSpecs) !== -1 && scopeOfWork.isComplete) ? '' : 'disabled'} isLocked={isLocked} canEdit={termConfig.canEdit} canAdd={termConfig.canAdd} calculateTerms={this.calculateTerms} />
				<BalanceSection contractAmount={ contractAmount } paymentAmount={ paymentAmount } termAmount={ termAmount } balance={ balance } className={ (infoCorrect === '1' && ['0', '1'].indexOf(hasSpecs) !== -1 && scopeOfWork.isComplete) ? '' : 'disabled'} isLocked={isLocked} />
				<section>
					<div className="inner compact">

						<table className="" cellPadding="0" cellSpacing="0">
							<tbody>
								<tr>
									<td />
									<td />
									<td>{ submitButton }</td>
									<td />
								</tr>
							</tbody>
						</table>

					</div>

				</section>

			</section>
		);
	}
}
